/*
 * Public API Surface of angular-resize-event
 */

export * from './lib/resized-event';
export * from './lib/resized.directive';
export * from './lib/angular-resized-event.module';
